module.exports = __webpack_public_path__ + "img/image05.a29309ca.png";